import StorageClient from './storage_client'
import * as Rx from 'rxjs'
import createId from './create_id'

const UID_KEY = '__nurve_uid'
const DISABLED_KEY = '__reject'

const DISABLED_VALUE = '1'

/**
 * トラッキングIDをユーザのブラウザに仕込み、読み取るためのクラス
 */
export default class TrackingManager {
  _uidChangedSubject: Rx.Subject<string | null>
  _storageClient: StorageClient | null

  constructor () {
    this._uidChangedSubject = new Rx.BehaviorSubject(null)
    this._storageClient = null
  }

  /**
   * @param {string} hubPage CrossStorageHubが設置されたページのURL
   */
  connect (hubPage: string): Promise<void> {
    const client = this._storageClient = new StorageClient(hubPage)
    return client.onConnect()
      .then(() => {
        return Promise.all([
          this._isTrackingDisabled(),
          client.getOrCreate(UID_KEY, () => createId())
        ])
      })
      .then(([disabled, uid]) => {
        this._uidChangedSubject.next(disabled ? null : uid)
        return Promise.resolve()
      })
  }

  _isTrackingDisabled (): Promise<boolean> {
    if (!this._storageClient) {
      return Promise.reject('StorageClient is not connected.')
    }
    return this._storageClient.get(DISABLED_KEY)
      .then((value) => {
        return value === DISABLED_VALUE
      })
  }

  onUidChangedAsObservable (): Rx.Observable<string | null> {
    return this._uidChangedSubject
  }
}
